<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex-be">
        <div class="search_condition">
          <el-select size="small" v-model="shelfStatus" clearable placeholder="请选择上下架状态"
                     class="search_condition_item m-r-20"
                     @change="getDataFn">
            <el-option
              v-for="item in shelfStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-select size="small" v-model="status" clearable placeholder="请选择审核状态" class="search_condition_item m-r-20"
                     @change="getDataFn">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-select size="small" v-model="solutionCategoryId" clearable placeholder="请选择分类板块"
                     class="search_condition_item m-r-20"
                     @change="getDataFn">
            <el-option
              v-for="item in solutionCategoryIdList"
              :key="item.id"
              :label="item.solutionName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="content_table">
        <tableTotal v-if="configTable.tableData.length>0" :index-show="configTable.indexShow"
                    :config-data="configTable.configData"
                    :table-data="configTable.tableData" :loading="configTable.loading"
                    @handleClick="handleClick">
        </tableTotal>
        <el-empty v-if="configTable.tableData.length<=0" description="暂无数据"></el-empty>
      </div>
      <div class="text-right m-t-20">
        <el-pagination
          @current-change="getDataFn"
          @size-change="handleSizeChange"
          :current-page.sync="configTable.current"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :page-sizes="[10,15,20]"
          :page-size="configTable.pageSize"
          :total="configTable.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 发布弹窗 -->
    <el-dialog
      title="查看详情"
      :visible.sync="seeDataDialog"
      :close-on-click-modal="true"
      width="1000px"
      v-dialogDrag>
      <writeEditor :editor='seeDataObj.solutionContent'></writeEditor>
    </el-dialog>
  </div>
</template>

<script>
  import tableTotal from "@/components/TableTotal/TableTotal";
  import writeEditor from "@/components/writeEditor/writeEditorShow";


  export default {
    name: "SolutionList",
    // import引入的组件需要注入到对象中才能使用
    components: {
      tableTotal, writeEditor
    },
    data() {
      return {
        shelfStatus: '',
        shelfStatusList: [
          {value: 0, label: '待上架'},
          {value: 1, label: '上架'},
          {value: 2, label: '下架'},
        ],
        status: '',
        statusList: [
          {value: 0, label: '待审核'},
          {value: 1, label: '审核通过'},
          {value: 2, label: '审核未通过'},
        ],
        // 分类id
        solutionCategoryId: '',
        solutionCategoryIdList: [],
        // 配置表格
        configTable: {
          loading: true,
          indexShow: false,
          configData: [
            {
              value: 'shopName',
              label: '商家名称',
              align: 'left'
            },
            {
              value: 'solutionCategoryName',
              label: '行业板块',
              align: 'left'
            },
            {
              value: 'solutionTitle',
              label: '解决方案标题',
              align: 'left',
              showOverflow: true,
            },
            {
              value: 'shelfStatus',
              label: '状态',
              align: 'left',
              objList: {
                0: '待上架',
                1: '上架',
                2: '下架',
              }
            },
            {
              value: 'status',
              label: '审核状态',
              align: 'left',
              objList: {
                0: '待审核',
                1: '审核通过',
                2: '审核未通过',
              }
            },
            {
              value: 'createTime',
              label: '创建时间',
              align: 'left',
              type: 'timeDate'
            },
            {
              label: '操作', width: '280', fixed: 'right', type: 'handleList', buttonList: [
                {label: '查看', event: 'seeData', show: true, showText: true},
                {
                  label: '编辑', event: 'editData', show: true, showText: true,
                  condition: row => {
                    return (row.status * 1 !== 1 || row.shelfStatus * 1 === 1);
                  }
                },
                {
                  label: '上架',
                  event: 'shelvesPut',
                  show: true,
                  showText: true,
                  text: '是否上架该方案?',
                  condition: row => {
                    return (row.status * 1 !== 1 || (row.shelfStatus * 1 !== 0 && row.shelfStatus * 1 !== 2));
                  }
                },
                {
                  label: '下架',
                  event: 'shelfLower',
                  show: true,
                  showText: true,
                  text: '是否下架该方案?',
                  condition: row => {
                    return (row.status * 1 !== 1 || row.shelfStatus * 1 !== 1);
                  }
                },
                {
                  label: '删除', event: 'delete', show: true, showText: true,
                  text: '确定删除该方案?',
                  condition: row => {
                    return (row.shelfStatus * 1 === 1);
                  }
                },
              ]
            }
          ],
          tableData: [],
          current: 1, // 当前页码
          total: 10, // 数据总条数
          pageSize: 10
        },
        seeDataObj: {},
        seeDataDialog: false,
      }
    },
    // 创建完成
    created() {
      this.info();
    },
    // 方法集合
    methods: {
      info() {
        this.getSolutionCategoryFn();
        this.getDataFn();
      },
      /**
       * @name: 获取解决方案分类列表
       * @description：solutionCategory
       * @author: king
       * @time：2022-10-12 19:08:16
       *
       */
      async getSolutionCategoryFn() {
        try {
          let res = await this.$http.post(this.$const.SellerCenter.solutionCategory);
          if (res && res.data) {
            console.log(res);
            this.solutionCategoryIdList = res.data;
          }
        } catch (e) {
          // console.log(e);
        }
      },
      async getDataFn() {
        let params = {
          pageNum: this.configTable.current,
          pageSize: this.configTable.pageSize,
          shelfStatus: this.shelfStatus,
          solutionCategoryId: this.solutionCategoryId,
          // 解决方案标题
          // solutionTitle: "",
          status: this.status,
          // 厂家id
          // supplierInfoId: ""
        };
        try {
          let res = await this.$http.post(this.$const.SellerCenter.getSolutionList_, params);
          if (res && res.data) {
            // console.log(res);
            this.configTable.tableData = res.data.list;
            this.configTable.total = res.data.total;
            this.configTable.loading = false;
          }
        } catch (e) {
          this.configTable.loading = false;
          // console.log(e);
        }
      },
      async handleClick(event, data, text) {
        // console.log(event, data, text);
        switch (event) {
          case 'seeData':
            this.$router.push({
              name: 'solutionDeail',
              params: {
                solutionID: data.id,
                solutionPlateID: data.solutionCategoryId
              }
            });
            break;
          case 'editData':
            this.$router.push({
              path: 'SellerCenter',
              query: {
                type: 'SolutionAdd',
                id: data.id
              }
            });
            break;
          case 'shelvesPut':
            this.isShelvesPut(data, 1);
            break;
          case 'shelfLower':
            this.isShelvesPut(data, 2);
            break;
          case 'delete':
            this.$confirm(text, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                await this.deleteFn(data);
              });
            break;
        }
      },
      async isShelvesPut(data, shelfStatus) {
        let params = {
          id: data.id,
          shelfStatus: shelfStatus
        };
        try {
          let res = await this.$http.put(this.$const.SellerCenter.solutionShelf, params);
          if (res && res.data) {
            // console.log(res);
            this.$message.success(this.$PubText.successCom);
            this.info();
          }
        } catch (e) {
          // console.log(e);
        }
      },
      async deleteFn(data) {
        try {
          let res = await this.$http.put(this.$const.SellerCenter.solutionDelete + data.id);
          if (res && res.data) {
            // console.log(res);
            this.$message.success(this.$PubText.successCom);
            this.info();
          }
        } catch (e) {
          // console.log(e);
        }
      },
      handleSizeChange(val) {
        this.configTable.pageSize = val;
        this.getDataFn();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .search_condition_item {
    width: 140px;
  }
</style>
